import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BillingService } from '../../../lib/services/billingService';
import { take } from 'rxjs/operators';
import { SelectPlanComponent } from '../select-plan/select-plan.component';
import { ModalService } from '../../../lib/services/modal.service';
import { selectPaymentState } from '../../../core/selectors/paymentState';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';

enum PlansStates {
  preview = 0,
  loading,
}

@Component({
  selector: 'mj-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss'],
})
export class PlansComponent implements OnInit {
  state = PlansStates.loading;
  unit_id;
  userSubscription;
  trialDueDate: Date;

  constructor(
    private billingService: BillingService,
    private modalService: ModalService,
    private store: Store<fromRoot.State>,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.unit_id = localStorage.getItem('unit_id');
    this.fetchSubscriptions();

    this.store
      .select(selectPaymentState)
      .pipe(take(1))
      .subscribe(payment => {
        if (payment.status === 'trialing') {
          this.trialDueDate = new Date(Number(payment.trial_end) * 1000);
        }
      });
  }

  fetchSubscriptions() {
    this.billingService
      .fetchSubscriptions(this.unit_id)
      .pipe(take(1))
      .subscribe(sub => {
        this.userSubscription = sub.data;
        this.state = PlansStates.preview;

        this.ref.detectChanges();
      });
  }

  onChangeSubscription() {
    this.modalService
      .appendComponentToBody(SelectPlanComponent, {
        userSubs: this.userSubscription,
      })
      .subscribe(data => {
        if (data) {
          this.userSubscription = data;
        }
        this.ref.detectChanges();
      });
  }
}
